const mediaSizes = {
  tabLand: '75em',
};

const devices = {
  tabLand: `(max-width: ${mediaSizes.tabLand})`,
};

export default devices;
